!function (global) {
  'use strict';

  var previouscallCharCounter = global.CharCounter;

  function CharCounter(options) {

    var options = options || {};
    var maxCharacters = 2000;
    var controlToLimit;
    var counterControl;

    // Init for Char Counter
    function init() {

      controlToLimit = options.controlToLimit;
      counterControl = options.counterControl;
      maxCharacters = options.maxCharacters;

      counterControl
        .text(controlToLimit.text().length)
        .after(' caracteres de ' + formatNumber(maxCharacters));
      controlToLimit.on('keydown keyup', evalMaxCharacters);
    }

    // Evaluate and no allow type more of maximum amount of characters
    function evalMaxCharacters(event) {
      var controlToEval = this;
      var charsCounted = controlToEval.value.length;

      counterControl.text(formatNumber(charsCounted));
    }

    // Format thousands for the number of characters
    function formatNumber(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    /*
      content parameter is the text into the text area if this not exist
      the character counter is reset and register zero
    */
    function updateCharCounter(content) {
      var contentLength;

      contentLength = content != null ? content.length : 0;
      counterControl.text(contentLength);
    }

    init();

    return {
      updateCharCounter: updateCharCounter
    }
  }

  CharCounter.noConflict = function noConflict() {
    global.CharCounter = previouscallCharCounter;
    return CharCounter;
  };

  global.CharCounter = CharCounter;

}(this);
